import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/common/Card/Card';
import Table from '../../components/common/Table/Table';
import LoadingSpinner from '../../components/common/LoadingSpinner/LoadingSpinner';
import StatusBadge from '../../components/common/StatusBadge/StatusBadge';
import SearchBar from '../../components/common/SearchBar/SearchBar';
import { getMyPocOwnerProjects } from '../../services/pocOwnerService';
import { formatDate } from '../../utils/helpers';
import styles from './PocOwnerProjects.module.css';

const PocOwnerProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setProjects(await getMyPocOwnerProjects());
      } catch (error) {
        console.error('Error fetching POC owner projects:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  const columns = [
    {
      header: 'Project Name',
      accessor: 'project_name',
      render: (row) => <span className={styles.projectName}>{row.project_name}</span>
    },
    {
      header: 'Student',
      accessor: 'student_name',
      render: (row) => row.student_name || '—'
    },
    {
      header: 'Track',
      accessor: 'project_track',
      render: (row) => (
        <span className={styles.track}>{row.project_track?.replace(/_/g, ' ').toUpperCase()}</span>
      )
    },
    {
      header: 'Status',
      accessor: 'status',
      render: (row) => <StatusBadge status={row.status} />
    },
    {
      header: 'Progress',
      accessor: 'planned_total_sessions',
      render: (row) => (row.planned_total_sessions ? `Planned: ${row.planned_total_sessions} sessions` : '—')
    },
    {
      header: 'Start Date',
      accessor: 'start_date',
      render: (row) => formatDate(row.start_date)
    },
    {
      header: 'Actions',
      accessor: 'actions',
      render: (row) => (
        <button className={styles.viewBtn} onClick={() => navigate(`/poc-owner/projects/${row.id}`)}>
          View Details
        </button>
      )
    }
  ];

  if (loading) {
    return (
      <div className={styles.loading}>
        <LoadingSpinner size="large" message="Loading projects..." />
      </div>
    );
  }

  const filteredProjects = projects.filter((p) => {
    const query = searchTerm.toLowerCase();
    return (p.project_name || '').toLowerCase().includes(query) ||
           (p.student_name || '').toLowerCase().includes(query);
  });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>My Projects</h1>
      </div>

      {projects.length > 0 && (
        <div className={styles.searchRow}>
          <SearchBar value={searchTerm} onChange={setSearchTerm} placeholder="Search by project or student name..." />
        </div>
      )}

      <Card>
        {projects.length === 0 ? (
          <div className={styles.empty}>
            <p>No projects assigned to you yet</p>
          </div>
        ) : filteredProjects.length === 0 ? (
          <div className={styles.empty}>
            <p>No projects match "{searchTerm}"</p>
          </div>
        ) : (
          <Table columns={columns} data={filteredProjects} />
        )}
      </Card>
    </div>
  );
};

export default PocOwnerProjects;
